import { SurveyPropertiesValidationError } from 'app/custom-errors/SurveyPropertiesValidationError'
import { IStructureElements } from 'app/interfaces/IStructureElements'
import { IStructureElementProperties } from 'app/interfaces/IStructureElementProperties'

export class SurveyStructureElementPropertyValidator implements IStructureElements {

  pages: {properties?: Record<string, IStructureElementProperties>; questionsGroupsIndex: Record<string, string[]>}
  pagesGroups: {properties?: Record<string, IStructureElementProperties>; pagesIndex: Record<string, string[]>}
  pagesGroupsIndex: string[]
  questionsGroups: {properties?: Record<string, IStructureElementProperties>; questionsIndex: Record<string, string[]>}

  constructor(structureElements: IStructureElements) {
    this.pages = structureElements.pages
    this.pagesGroups = structureElements.pagesGroups
    this.pagesGroupsIndex = structureElements.pagesGroupsIndex
    this.questionsGroups = structureElements.questionsGroups
  }

  validate() {

    const requiredProperties = Object.getOwnPropertyNames(this)
    const missingProperties: string[] = []
    for (const idx in requiredProperties) {
      if (this[requiredProperties[idx]] === undefined || this[requiredProperties[idx]] === null) {
        missingProperties.push(requiredProperties[idx])
      }
    }

    if (missingProperties.length) {
      throw new SurveyPropertiesValidationError().missingStructureElements(missingProperties)
    }

  }
}
